<div class="flex h-[500px] flex-col">
  <div class="mt-3 flex-1 space-y-3 overflow-y-auto px-2 pb-10">
    <!-- feature: item per page -->
    <div class="item-per-page space-y-3">
      <div class="item-per-page-options">
        <h2 class="mb-3 font-medium">Item Per Page</h2>
        <div class="flex flex-wrap gap-3">
          <button
            type="button"
            autofocus
            class="cursor-pointer rounded-full border border-slate-300 px-2 py-1 dark:border-slate-800"
            [ngClass]="{
              'bg-slate-200 dark:bg-slate-800':
                itemPerPageOption.value == itemPerPage
            }"
            *ngFor="let itemPerPageOption of itemPerPageOptions"
            (click)="itemPerPage = itemPerPageOption.value">
            {{ itemPerPageOption.label }}
          </button>
        </div>
      </div>
    </div>
    <!-- feature: On Page -->
    <div class="form">
      <h2 class="mb-3 font-medium">Page</h2>
      <p-inputNumber
        class="w-full"
        styleClass="text-slate-300 w-full"
        [(ngModel)]="curPage"
        [showButtons]="true"
        [min]="1"
        [max]="totalPages"
        mode="decimal"></p-inputNumber>
    </div>
  </div>
</div>

<div class="action flex justify-end gap-3 pt-3">
  <button
    type="button"
    class="fc-animate-translate-up btn-emerald flex items-center gap-2 rounded-md p-4 text-sm md:py-2 md:px-4"
    (click)="submit()">
    Submit
  </button>
</div>
